import { DownloadKsyosDesktopLink } from './DownloadKsyosDesktopLink';

export function HolterTimeoutText() {
    return (
        <>
            Het lijkt erop dat de Ksyos koppeling nog niet op deze computer is geïnstalleerd.{' '}
            <DownloadKsyosDesktopLink />
        </>
    );
}
